import styled from "styled-components";

export const PollView = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxx_small }px;

  & > div.poll-card {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.x_small }px;
    padding: ${({ theme }) => theme.spacing.x_small }px;
    border-radius: ${({ theme }) => theme.border_radius.medium }px;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.info.default }1F, ${({ theme }) => theme.colors.text.default }0F);
    border: 1px solid ${({ theme }) => theme.colors.info.default }33;
    color: ${({ theme }) => theme.colors.text.default };
    text-align: left;
  }

  & div.poll-head {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
  }

  & div.poll-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    background-color: ${({ theme }) => theme.colors.info.default }22;
    color: ${({ theme }) => theme.colors.info.default };
  }

  & div.poll-title {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    min-width: 0;
  }

  & div.poll-title > span {
    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.info.default };
  }

  & div.poll-title > strong {
    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-weight: 700;
  }

  & div.poll-options {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
  }

  & div.poll-options > button {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
    min-height: 38px;
    overflow: hidden;
    padding: ${({ theme }) => `${ theme.spacing.xx_small }px ${ theme.spacing.x_small }px`};
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    border: 1px solid ${({ theme }) => theme.colors.text.default }22;
    background-color: ${({ theme }) => theme.colors.text.default }0D;
    color: ${({ theme }) => theme.colors.text.default };
    cursor: pointer;
    text-align: left;
    transition: border-color .16s ease, background-color .16s ease, transform .16s ease;
  }

  & div.poll-options > button:hover,
  & div.poll-options > button:focus-visible {
    border-color: ${({ theme }) => theme.colors.info.default }AA;
    background-color: ${({ theme }) => theme.colors.info.default }1A;
    outline: none;
  }

  & div.poll-options > button:active {
    transform: scale(.99);
  }

  & div.poll-options > button.selected {
    border-color: ${({ theme }) => theme.colors.info.default };
    background-color: ${({ theme }) => theme.colors.info.default }22;
  }

  & span.poll-progress {
    position: absolute;
    inset: 0 auto 0 0;
    z-index: 0;
    width: 0;
    background-color: ${({ theme }) => theme.colors.info.default }24;
    transition: width .24s ease;
  }

  & span.poll-option-label,
  & span.poll-percent {
    position: relative;
    z-index: 1;
  }

  & span.poll-option-label {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
    min-width: 0;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-weight: 600;
  }

  & span.poll-radio {
    display: block;
    min-width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.colors.text.default }88;
    box-shadow: inset 0 0 0 2px transparent;
    transition: border-color .16s ease, box-shadow .16s ease, background-color .16s ease;
  }

  & button.selected span.poll-radio {
    border-color: ${({ theme }) => theme.colors.info.default };
    background-color: ${({ theme }) => theme.colors.info.default };
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme.chatBubble.received };
  }

  & span.poll-percent {
    min-width: 34px;
    text-align: right;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.info.default };
  }

  & span.poll-empty {
    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    color: ${({ theme }) => theme.colors.text.default }AA;
  }

  & div.poll-foot {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
    color: ${({ theme }) => theme.colors.text.default }AA;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
  }

  & div.poll-foot > span {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
  }
`;
